import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatToolbarModule } from "@angular/material/toolbar";

import { LorenNotificationRoutingModule } from "./loren-notification-routing.module";
import { LorenNotificationDetailsComponent } from "./components/loren-notification-details/loren-notification-details.component";
import { LorenNotificationResolver } from "./resolvers/loren-notification.resolver";
import { LorenDateModule } from "../../shared/pipes/loren-date/loren-date.module";
import { LorenCardModule } from "../../shared/modules/loren-card/loren-card.module";
import { LorenBaseMapModule } from "../../shared/modules/loren-base-map/loren-base-map.module";
import { LorenTrimModule } from "../../shared/pipes/loren-trim/loren-trim.module";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";

@NgModule({
  declarations: [LorenNotificationDetailsComponent],
  providers: [LorenNotificationResolver],
  imports: [
    CommonModule,
    FormsModule,
    ScrollingModule,
    MatToolbarModule,
    MatIconModule,
    MatFormFieldModule,
    MatListModule,
    MatButtonModule,
    MatInputModule,

    LorenNotificationRoutingModule,
    LorenDateModule,
    LorenCardModule,
    LorenBaseMapModule,
    LorenTrimModule,
    LorenPageContentComponent,
  ],
})
export class LorenNotificationModule {}
